import * as stateManagement from '#packages/stateManagement';

export const { siteScaleSel, zoomModeSel, isPinModeSel } =
  stateManagement.stateMapperArgsSelectors.otherSels;
